import {
  useEffect,
} from "react";

import {
  X,
} from "lucide-react";

const Modal = ({
  open = false,
  title,
  eyebrow,
  children,
  footer,
  onClose,
  size = "medium",
}) => {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleKeyDown = (
      event
    ) => {
      if (
        event.key === "Escape"
      ) {
        onClose?.();
      }
    };

    document.addEventListener(
      "keydown",
      handleKeyDown
    );

    const previousOverflow =
      document.body.style
        .overflow;

    document.body.style.overflow =
      "hidden";

    return () => {
      document.removeEventListener(
        "keydown",
        handleKeyDown
      );

      document.body.style.overflow =
        previousOverflow;
    };
  }, [
    open,
    onClose,
  ]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="app-modal-backdrop"
      role="presentation"
      onMouseDown={(
        event
      ) => {
        if (
          event.target ===
          event.currentTarget
        ) {
          onClose?.();
        }
      }}
    >
      <section
        className={`app-modal app-modal-${size}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <header className="app-modal-header">
          <div>
            {eyebrow && (
              <p className="app-modal-eyebrow">
                {eyebrow}
              </p>
            )}

            <h2>
              {title}
            </h2>
          </div>

          <button
            type="button"
            className="app-modal-close"
            onClick={
              onClose
            }
            aria-label="Close"
          >
            <X size={21} />
          </button>
        </header>

        <div className="app-modal-body">
          {children}
        </div>

        {footer && (
          <footer className="app-modal-footer">
            {footer}
          </footer>
        )}
      </section>
    </div>
  );
};

export default Modal;